module.exports = __webpack_public_path__ + "img/7.66a2a6bb.png";